import { render, staticRenderFns } from "./AddLotin.vue?vue&type=template&id=6fff6e30&"
import script from "./AddLotin.vue?vue&type=script&lang=js&"
export * from "./AddLotin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports